<div appInfinteScroll *ngIf="isStoreItems" (window:resize)="onResize()" (scrolledEnd)="scrollEnd()" (scrolledCur)="scrollCur($event)">
  <div [style.height]=infiniteScrollService.totalHeight>
    <div class="row w-90" *ngFor="let row of rowList" [style.transform]=infiniteScrollService.translateHeight>
      <div class="col-6 col-sm-4 col-md-4 col-lg-3 col-xl-2" *ngFor="let storeItem of row; trackBy: trackByItemName">
        <a routerLink='{{ storeItem.storeItemId }}' id="store_item_detail_link">
          <div class="card" id="sd_store_card" (click)="deleteAlert()">
            <div class="card-body" id="override_card_body">
              <img id="card_image" class="card-top-img"
                [src]="_DomSanitizer.bypassSecurityTrustUrl('data:' + storeItem.iconMime + ';base64, ' + storeItem.iconData)">
            </div>
            <div class="card-footer text-center pb-3" id="store_item_name"
              *ngIf="storeItem.storeItemName.length<22; else elseBlock" [innerHTML]="storeItem.storeItemName"></div>
            <ng-template #elseBlock>
              <div class="card-footer text-center pb-3" id="store_item_name_lg" data-animation="true"
                data-toggle="tooltip" data-placement="left" title="{{storeItem.storeItemName}}"
                [innerHTML]="storeItem.storeItemName.slice(0,19)+'...'">
              </div>
            </ng-template>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Spinner -->
<div class="text-center col-12" id="sd_store_item_loading ">
  <div *ngIf="isLoading" id="spinner" role="progressbar">
    <zsd-spinner></zsd-spinner>
  </div>
</div>

    <div *ngIf="!isStoreItems && !isLoading" class="text-center" id="store_items_message">
      <div class="card" id="noStoreItems">
        <div class="card-body">
            {{ 'CommonStrings.noRecords' | translate }}
    </div>
  </div>
</div>